import { createContext, useContext } from 'react'

/**
 * Home's own agent launch, for a surface rendered inside it that needs to open
 * an agent the way a launcher tile does — a failed turn's "new conversation".
 * Home provides it from launchAgent, so its branching (in-frame face, sub-app
 * host, handover composer) and the pane's patient frame are the ones a tile
 * uses; a surface outside Home has none and offers no launch.
 */
export interface AgentLauncher {
  /** Whether this caller may open the agent from here. */
  canLaunch: (slug: string) => boolean
  launch: (slug: string) => void
}

export const AgentLauncherContext = createContext<AgentLauncher | null>(null)

export function useAgentLauncher(): AgentLauncher | null {
  return useContext(AgentLauncherContext)
}
